<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="titlepage">
<span aria-label="5" id="pg_5" role="doc-pagebreak">
<figure class="IMG" id="tit"><img alt="Space Station Down by Ben Bova and Doug Beason" class="img90" src="images/01_83182_ch01_4P.jpg"/>
</figure>
</span></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5b6d7e24